export default __webpack_public_path__ + "static/media/Screenshot (208).2c2d16eb.png";